import _ from 'underscore'

$(->
  # SETTINGS > OFFER LETTER TEMPLATES > NEW/EDIT

  ## Populates the list of variable fields specified on the template that can then be reordered, edited, etc.
  $('.offer_letter_template #subitems_holder').on 'subitems:updated', ->
    $.get "#{$('form.offer_letter_template').attr('action')}.json", (data)->
      tags = {}
      _.each data.questions, (question)->
        tags["{% question_response #{question.id} %}"] = question.name
      config = $('#offer_letter_template_content').data('context')
      config.custom = { label: 'Variable Fields', tags: tags }
      tinymce.EditorManager.get('offer_letter_template_content').execCommand('cpliquidReset')

)
